import {
  RESOURCE_ALLOCATION_PERMISSION,
  RESOURCE_REQUEST_PERMISSION
} from '~/modules/common/enums';
import { useMeContext } from '~/modules/me/useMeContext';

export const getProjectResourceAllocationPermissions = ({
  permissionsMap,
  isPsaRmpEnhancedProjectManagerPersonaEnabled
}) => {
  const isCompletedResourceAllocationEditAllowed = Boolean(
    permissionsMap[
      RESOURCE_ALLOCATION_PERMISSION.WEBUI_EDIT_COMPLETE_RESOURCE_ALLOCATION
    ]
  );
  const canViewResourceAssignments = Boolean(
    permissionsMap[RESOURCE_REQUEST_PERMISSION.VIEW_RESOURCE_ASSIGNMNET]
  );
  const canViewResourceAllocationPermission = Boolean(
    permissionsMap[RESOURCE_ALLOCATION_PERMISSION.VIEW_RESOURCE_ALLOCATION]
  );
  const canEditResourceAllocationPermission = Boolean(
    permissionsMap[RESOURCE_ALLOCATION_PERMISSION.EDIT_RESOURCE_ALLOCATION]
  );

  return {
    canEditResourceAllocation:
      isCompletedResourceAllocationEditAllowed ||
      (isPsaRmpEnhancedProjectManagerPersonaEnabled &&
        canEditResourceAllocationPermission),
    canViewResourceAllocation: isPsaRmpEnhancedProjectManagerPersonaEnabled
      ? canViewResourceAssignments || canViewResourceAllocationPermission
      : true
  };
};

export const useProjectResourceAllocationPermissions = () => {
  const {
    permissionsMap,
    featureFlags: { isPsaRmpEnhancedProjectManagerPersonaEnabled }
  } = useMeContext();

  return getProjectResourceAllocationPermissions({
    permissionsMap,
    isPsaRmpEnhancedProjectManagerPersonaEnabled
  });
};
